"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cartesian2dTraceEntityConnector = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Generates traces in increments of 2, 5 or 10 in order to fit within maxTraceCount. The actual trace count may be
 * up to maxTraceCount + 1.
 */
class Cartesian2dTraceEntityConnector {
    constructor(rangeCtor, maxTraceCount, changeIdGenerator) {
        this.maxTraceCount = maxTraceCount;
        this.changeIdGenerator = changeIdGenerator;
        this.xStart = 0;
        this.xStep = 0;
        this.yStart = 0;
        this.yStep = 0;
        this.xCount = 0;
        this.yCount = 0;
        this.dataRange = rc_js_util_1.Range2d.getCtor(rangeCtor).factory.createOneEmpty();
    }
    update(dataRange) {
        this.dataRange = dataRange;
        const xTickSize = this.getTickSize(dataRange.getXRange());
        const yTickSize = this.getTickSize(dataRange.getYRange());
        this.xStart = Cartesian2dTraceEntityConnector.getStart(dataRange.getXMin(), xTickSize);
        this.yStart = Cartesian2dTraceEntityConnector.getStart(dataRange.getYMin(), yTickSize);
        this.xCount = Cartesian2dTraceEntityConnector.getCount(this.xStart, xTickSize, dataRange.getXMax());
        this.yCount = Cartesian2dTraceEntityConnector.getCount(this.yStart, yTickSize, dataRange.getYMax());
        this.xStep = xTickSize;
        this.yStep = yTickSize;
        return this.changeIdGenerator.getNextId();
    }
    getXTick(index) {
        return this.xStart + this.xStep * index;
    }
    getYTick(index) {
        return this.yStart + this.yStep * index;
    }
    getTraceCount() {
        return this.xCount + this.yCount;
    }
    getXTraceCount() {
        return this.xCount;
    }
    getYTraceCount() {
        return this.yCount;
    }
    getTickSize(range) {
        const exponent = Math.round(Math.log10(range));
        let tickSize = Math.pow(10, exponent - 1);
        // tickSize may not be representable exactly,
        // round to avoid float funnies
        const ticksInRange = Math.round(range / tickSize);
        if (ticksInRange <= this.maxTraceCount) {
            // no action needed
        }
        else if (ticksInRange * 0.5 <= this.maxTraceCount) {
            tickSize *= 2;
        }
        else if (ticksInRange * 0.2 <= this.maxTraceCount) {
            tickSize *= 5;
        }
        else {
            tickSize *= 10;
        }
        return tickSize;
    }
    static getStart(min, tickSize) {
        const firstTick = ((min / tickSize) | 0) * tickSize;
        if (firstTick < min) {
            return firstTick + tickSize;
        }
        else {
            return firstTick;
        }
    }
    static getCount(start, tickSize, end) {
        return 1 + ((end - start) / tickSize) | 0;
    }
}
exports.Cartesian2dTraceEntityConnector = Cartesian2dTraceEntityConnector;
//# sourceMappingURL=cartesian-2d-trace-entity-connector.js.map